<template>
    <v-navigation-drawer permanent>
        <v-toolbar flat color="primary" class="white--text" dark>
            <v-list>
                <v-list-item>
                    <v-list-item-title class="title">
                        Menu
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-toolbar>
        <v-divider></v-divider>
        <v-list dense class="pt-0">
                <v-list-item :to="{name: 'UsersAdmin'}" v-if="$can('do','Pages.Users')">
                    <v-list-item-action>
                        <v-icon>fa-users</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                            <v-list-item-title>Użytkownicy</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{name: 'RolesAdmin'}" v-if="$can('do','Pages.Roles')">
                    <v-list-item-action>
                        <v-icon>fa-user-tag</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                            <v-list-item-title>Role</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{name: 'RoomsAdmin'}" v-if="$can('do','POKO_Rooms')">
                    <v-list-item-action>
                        <v-icon>fa-door-open</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                            <v-list-item-title>Gabinety</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'SigningTemplates'}" v-if="$can('do','POKO_Podpisy_Szablony')">
                    <v-list-item-action>
                        <v-icon>fa-file-signature</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                            <v-list-item-title>Szablony do podpisu</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'SigningTerminals'}" v-if="$can('do','POKO_Podpisy_Terminale')">
                    <v-list-item-action>
                        <v-icon>fa-tablet-alt</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                            <v-list-item-title>Terminale (tablety)</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'CompanySettings'}" v-if="$can('do','POKO_Ustawienia_Firmy')">
                    <v-list-item-action>
                        <v-icon>fa-building</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                            <v-list-item-title>Ustawienia Firmy</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'DniWolne'}" v-if="$can('do','POKO_DniWolne_Dodawanie')">
                  <v-list-item-action>
                    <v-icon>fa-sun</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Dni wolne</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'SendSmsConfiguration'}" v-if="$can('do','POKO_AndroidWysylkaSMSKOnfiguracja') && isAndroidSMSEnabled">
                  <v-list-item-action>
                    <v-icon>fa-mobile-alt</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Wysyłka SMS - konfiguracja</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!--<v-list-item :to="{name: 'PokoSmsConfiguration'}" v-if="$can('do','POKO_AndroidWysylkaSMSKOnfiguracja')">
                  <v-list-item-action>
                    <v-icon>fa-sms</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Wysyłka SMS - konfiguracja (POKO)</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>-->
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import {  mapState } from "vuex";
export default {
   name: 'AdminNav',
    data() {
        return {
            
        }
    },
    computed: {
        ...mapState('featuresModule',['features']),
        isAndroidSMSEnabled: function() {
            return this.features && this.features.AndroidSMS
        }
    }
}
</script>

<style>

</style>
